<template>
  <el-table-column
    prop="cancelled_representative_placement.receipt_number"
    sortable="custom"
    label="Kapcsolódó sztornózott kihelyezés"
    show-overflow-tooltip
    min-width="290"
  >
    <template slot-scope="scope">
      {{ scope.row.cancelled_representative_placement_receipt_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'cancelled_representative_placement.receipt_number',
};
</script>
